
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-53fb7083!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./productPhoto.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./productPhoto.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-53fb7083!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./productPhoto.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/ProductAttribute/productPhoto.vue
// module id = 568
// module chunks = 2